import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface Payment {
  invoice: number;
  paymentDate: string;
  cashPaid: number;
  visaPaid: number;
  contactlessCashPaid: number;
  creator: string;
}

export interface PaymentsDialogData {
  subscriptionId?: number;
  payments?: Payment[];
}

@Component({
  selector: "fury-payments",
  templateUrl: "./payments.component.html",
  styleUrls: ["./payments.component.scss"],
})
export class PaymentsComponent {
  payments: Payment[] = [];
  currentPage: number = 1;
  totalPages: number = 1;

  constructor(
    private dialogRef: MatDialogRef<PaymentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaymentsDialogData,
  ) {}

  ngOnInit(): void {
    // Load payments from data
    if (this.data?.payments) {
      this.payments = this.data.payments;
    }

    // Example data for demo (remove in production):
    this.payments = [
      {
        invoice: 1,
        paymentDate: "2026-02-15 09:40:18",
        cashPaid: 100,
        visaPaid: 0,
        contactlessCashPaid: 0,
        creator: "managmenth2",
      },
    ];

    // Calculate total pages (if implementing pagination)
    this.totalPages = Math.ceil(this.payments.length / 10);
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
